<template>
    <form-view class="user-account-view">
        <template slot="before"><veui-steps :steps="steps" :current="2"/></template>
        <h3>设置领券奖项</h3>
        <veui-button ui="primary" @click="download(store.api.appServiceLotteryDownload)">下载券码模板</veui-button>
        <veui-table :data="awardList">
            <veui-table-column field="name" title="奖项名称"/>
            <veui-table-column field="description" title="奖项描述">
            </veui-table-column>
            <veui-table-column field="availablePerDay" title="每日最多领取测试券码数">
            </veui-table-column>
            <veui-table-column field="totalNum" title="测试券码总数">
            </veui-table-column>
            <veui-table-column field="acceptedNum" title="已领测试券码数量">
            </veui-table-column>
            <veui-table-column field="operations" title="上传券码">
                <template slot-scope="props">
                    <uploader :max-count="1"
                        @success="uploadSuccess"
                        @statuschange="switchBtnStatus"
                        :action="store.api.appServiceLotteryUpload" :payload="props.payload">
                        <span slot="button-label">{{ btnText }}</span>
                    </uploader>
                </template>
            </veui-table-column>
        </veui-table>
        <div slot="after" class="operations">
            <veui-button v-if="isDraft" ui="primary" v-bind="btnStatus"
                @click="publish">发布服务</veui-button>
            <veui-button v-if="store.formerPageType"
                v-bind="btnStatus" @click="back">返回上一步</veui-button>
            <veui-button v-bind="btnStatus" @click="goToServiceList">完成</veui-button>
        </div>
    </form-view>
</template>

<script>
import FormView from '@baidu/ve-ria/views/FormView';
import FormModel from './FormModel';
import createView from '@baidu/ve-ria/views/createView';
import {Steps, Field, Button, Input, Span, Dialog, Textarea, Table, Column} from 'veui';
import SearchSelect from '@/common/components/SearchSelect';
import serviceMixin from '@/common/mixins/service';
import uploaderMixin from '@/common/mixins/uploader';
import {get} from 'lodash';

export default createView(FormView, FormModel, {
    name: 'AccountView',
    components: {
        'veui-field': Field,
        'veui-input': Input,
        'veui-span': Span,
        'veui-button': Button,
        'veui-table-column': Column,
        'veui-steps': Steps,
        'veui-dialog': Dialog,
        'veui-textarea': Textarea,
        'veui-table': Table,
        SearchSelect
    },
    mixins: [serviceMixin, uploaderMixin],
    data() {
        return {
            steps: [
                {
                    label: '填写基本信息'
                },
                {
                    label: '设置奖项券码'
                },
                {
                    label: '发布服务'
                }
            ]
        };
    },
    computed: {
        awardList() {
            return get(this.store.serviceDetail, 'awards', []);
        },
        btnText() {
            return this.isDraft ? '上传测试券码' : '上传正式券码';
        }
    },
    methods: {
        async publish() {
            await this.store.requestPublish();
            this.store.requestDetail();
        },
        uploadSuccess() {
            this.showToast('上传成功', {type: 'success'});
        }
    }
});
</script>

<style lang="less">
.user-account-view {
    .award-item {
        display: block;
    }
    .veui-uploader {
        .veui-uploader-list {
            display: none;
        }
    }
    .operations {
        margin-top: 20px;
        .veui-button {
            &+.veui-button {
                margin-left: 20px;
            }
        }
    }
}
.add-award-dialog {
    .veui-dialog-content {
        width: 600px;
    }
}
</style>
